// Centralized defaults for preference-related frontend state.

const FALLBACK_TIMEZONE = 'America/Toronto';

export const getSystemTimezoneOrFallback = () => {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || FALLBACK_TIMEZONE;
    } catch (e) {
        return FALLBACK_TIMEZONE;
    }
};

// Tenant/business preference defaults (flat API shape used by settings and hooks).
export const createDefaultTenantPreferences = () => ({
    country: 'Canada',
    phoneNumberFormat: '(###) ###-####',
    phoneNumberCountryCode: '+1',
    timezone: getSystemTimezoneOrFallback(),
    currency: 'CAD',
    currencySymbol: '$',
    dateFormat: 'YYYY-MM-DD',
    postalCodeFormat: 'A1A 1A1',
    invoiceNumberFormat: 'INV-{YYYY}-{####}',
    prescriptionNumberFormat: 'RX-{YYYY}-{####}',
    companyName: 'OptoDesk',
    allowCloseWithBalance: false,
    lowStockQuantityThreshold: 5,
    opticalEntryMode: 'catalog'
});

// Location preferences component expects legacy field keys in this shape.
export const DEFAULT_LOCATION_BUSINESS_PREFERENCES = {
    phoneFormat: '(###) ###-####',
    countryCode: '+1',
    timezone: 'America/Toronto',
    currency: 'CAD',
    currencySymbol: '$',
    dateFormat: 'YYYY-MM-DD',
    postalCodeFormat: 'A1A 1A1',
    invoiceFormat: 'INV-{YYYY}-{####}',
    prescriptionFormat: 'RX-{YYYY}-{####}',
    lowStockQuantityThreshold: 5
};

export const EMPTY_LOCATION_PREFERENCE_OVERRIDES = {
    phoneFormat: '',
    countryCode: '',
    timezone: '',
    currency: '',
    dateFormat: '',
    postalCodeFormat: '',
    invoiceFormat: '',
    prescriptionFormat: '',
    lowStockQuantityThreshold: ''
};
